// extracted by mini-css-extract-plugin
export default {"editAction":"Button_editAction__SF0Ma","deleteAction":"Button_deleteAction__8HSqB","secondary":"Button_secondary__Gc1ag"};